import { useState } from "react";
import SendMessageIconSVG from "../../../assets/icons/svg/SendMessageIconSVG";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { useDispatch } from "react-redux";
import { sendMessage } from "../../../reduxStore/entities/messages";
import { getTargetUserId } from "../../../utils/helpers/messagesHelpers/getTargetUserId";
import { ulid } from "ulid";

export const SendMessageForm = ({
    partOfferId,
    conversationUserIds,
}) => {
    const dispatch = useDispatch();
    const [messagePayload, setMessagePayload] = useState('');

    const targetUserId = getTargetUserId(conversationUserIds);

    const getMessagePayload = () => {
        return {
            part_offer_id: partOfferId,
            target_user_id: targetUserId,
            body: messagePayload,
            ulid: ulid()
        };
    };

    const handleMessageSend = async () => {
        try {
            const values = getMessagePayload();
            dispatch(sendMessage(values));
            setMessagePayload('');
        }

        catch (error) {
            console.error(error);
        };
    };

    return (
        <div style={styles.mainContianer}>

            <input
                value={messagePayload}
                onChange={(e) => setMessagePayload(e.target.value)}
                placeholder="Upiši poruku za prodavca"
                style={styles.input}
            />

            <div
                onClick={() => handleMessageSend()}
                style={styles.sendMessageButtonContianer}
            >
                <SendMessageIconSVG />
            </div>
        </div>
    );
};

export default SendMessageForm;

const styles = {
    mainContianer: {
        display: 'flex',
        alignItems: 'center',
        width: "340px",
        border: "1px solid #0000003b",
        borderRadius: 4,
        padding: "10px"
    },
    input: {
        flex: 1,
        backgroundColor: 'transparent',
        border: "1px solid transparent",
        borderRadius: 6,
        paddingInline: 8,
        fontFamily: FontEnum.TITILIUM_WEB,
    },
    sendMessageButtonContianer: {
        display: 'flex',
        height: "40px",
        width: "40px",
        borderRadius: 8,
        backgroundColor: "#7C3AED",
        alignItems: 'center',
        justifyContent: 'center'
    }
}